"use client";

import React, { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeritageHospitality() {
  const [scrollY, setScrollY] = useState(0);
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  return <section data-section-id="223889" id="a-note-from-anthony-lily" className="bg-background text-foreground relative w-full min-h-screen flex items-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 opacity-[0.08] pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/elegant_linen_texture_pattern.png)] bg-cover bg-no-repeat bg-center mix-blend-multiply" aria-hidden="true" />

      <div className="container mx-auto px-4 py-20 md:py-32 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-center">
          
          {}
          <div ref={imgRef} className={`lg:col-span-5 relative h-[60vh] lg:h-[85vh] w-full overflow-hidden rounded-md border-[12px] border-white shadow-xl transition-all duration-1000 ease-out ${isImgVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="absolute inset-0 w-full h-full top-0 will-change-transform" style={{
            transform: `translateY(${scrollY * 0.15}px)`
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/hero_couple.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/hero_couple.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/hero_couple.png-wvc-sizes" alt="Anthony and Lily Portrait" className="w-full object-cover object-center !h-[752.25px] relative bottom-[150px]" loading="lazy" />
              {}
              <div className="absolute inset-0 bg-primary/5 mix-blend-soft-light" />
            </div>
          </div>

          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col justify-center space-y-10 lg:pl-8 xl:pl-16 transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="space-y-6">
              <h2 className="font-default text-4xl md:text-5xl lg:text-7xl font-light italic tracking-tight text-foreground">
                "Our journey is just beginning."
              </h2>
              <div className="w-20 h-[1px] bg-primary/30" />
            </div>

            <div className="space-y-6 text-muted-foreground font-serif text-lg md:text-xl leading-relaxed max-w-2xl">
              <p>
                We are so incredibly grateful to have you join us as we celebrate 
                the start of our new life together. This day is a reflection of 
                the love and support you have shown us throughout our journey, 
                and we couldn't imagine saying "I do" without you by our side.
              </p>
              <p>
                From our first meeting to this beautiful milestone, every moment 
                has been a gift. We hope this celebration is as joyful and 
                memorable for you as it is for us. Thank you for being part of 
                our story and for sharing in the magic of our wedding day.
              </p>
            </div>

            <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center gap-8 border-t border-border/40">
              
              <div className="sm:ml-auto">
                <Button asChild variant="outline" size="lg" className="rounded-md border-primary/20 hover:bg-primary hover:text-primary-foreground transition-colors font-default uppercase tracking-widest text-xs">
                  <Link to="/OurStoryPage">Read Our Story</Link>
                </Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}